let container: HTMLDivElement | null = null;

function getContainer(): HTMLDivElement {
  if (!container) {
    container = document.createElement("div");
    container.id = "zs-toast-container";
    container.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9999;
      display: flex;
      flex-direction: column-reverse;
      gap: 10px;
      pointer-events: none;
    `;
    document.body.appendChild(container);
  }
  return container;
}

const icons: Record<string, string> = {
  success: "\u2714",
  error: "\u2716",
  warning: "\u26A0",
  info: "\u2139",
};

const iconColors: Record<string, string> = {
  success: "#38A169",
  error: "#E53E3E",
  warning: "#D69E2E",
  info: "#3182CE",
};

export function showToast(options: {
  title: string;
  description?: string;
  status?: "success" | "error" | "warning" | "info";
  duration?: number;
  isClosable?: boolean;
  position?: string;
}) {
  const { title, description, status = "info", duration = 3000 } = options;
  const toastContainer = getContainer();

  const toast = document.createElement("div");
  toast.style.cssText = `
    pointer-events: auto;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 18px;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    min-width: 280px;
    max-width: 400px;
    animation: zs-toast-in 0.3s ease;
    position: relative;
  `;

  // Inject keyframes once
  if (!document.getElementById("zs-toast-keyframes")) {
    const style = document.createElement("style");
    style.id = "zs-toast-keyframes";
    style.textContent = `
      @keyframes zs-toast-in {
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes zs-toast-out {
        from { opacity: 1; transform: translateY(0); }
        to { opacity: 0; transform: translateY(12px); }
      }
    `;
    document.head.appendChild(style);
  }

  // Icon
  const iconEl = document.createElement("span");
  iconEl.textContent = icons[status] || icons.info;
  iconEl.style.cssText = `
    font-size: 18px;
    color: ${iconColors[status] || iconColors.info};
    flex-shrink: 0;
    line-height: 1;
    margin-top: 1px;
  `;

  // Text content
  const textWrapper = document.createElement("div");
  textWrapper.style.cssText = "flex: 1; min-width: 0;";

  const titleEl = document.createElement("div");
  titleEl.textContent = title;
  titleEl.style.cssText = `
    font-size: 14px;
    font-weight: 600;
    color: #1A202C;
    line-height: 1.4;
  `;

  textWrapper.appendChild(titleEl);

  if (description) {
    const descEl = document.createElement("div");
    descEl.textContent = description;
    descEl.style.cssText = `
      font-size: 13px;
      color: #718096;
      line-height: 1.4;
      margin-top: 2px;
    `;
    textWrapper.appendChild(descEl);
  }

  // Close button
  const closeBtn = document.createElement("span");
  closeBtn.textContent = "\u2715";
  closeBtn.style.cssText = `
    font-size: 14px;
    color: #A0AEC0;
    cursor: pointer;
    flex-shrink: 0;
    line-height: 1;
    padding: 2px;
    transition: color 0.15s;
  `;
  closeBtn.onmouseenter = () => { closeBtn.style.color = "#4A5568"; };
  closeBtn.onmouseleave = () => { closeBtn.style.color = "#A0AEC0"; };

  const remove = () => {
    toast.style.animation = "zs-toast-out 0.3s ease forwards";
    setTimeout(() => toast.remove(), 300);
  };

  closeBtn.onclick = remove;

  toast.appendChild(iconEl);
  toast.appendChild(textWrapper);
  toast.appendChild(closeBtn);
  toastContainer.appendChild(toast);

  setTimeout(remove, duration);
}
